var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeHero'),_c('SkillsSection'),_c('TestimSlider',{attrs:{"normalQuotes":true}}),_c('Partners'),_c('Eestec')],1)}
var staticRenderFns = []

export { render, staticRenderFns }